import { useArticleById } from '@services/articles'
import { momentToString } from '@shared/innmaxLib/utils/webHelper'
import { Loading } from '@shared/innmaxUI'
import { Radio } from '@shared/innmaxUI/Form'
import cx from 'classnames'
import React from 'react'
import { useParams } from 'react-router-dom'
import { css } from 'styled-components'

const ArticlePreview = (props: { articleContent?: string }) => {
  const { articleContent } = props
  const { id } = useParams<{ id: string }>()

  const mode = !!id ? 'fetchData' : 'fromProps'

  const { data: _article, isLoading } = useArticleById(id, {
    enabled: mode === 'fetchData',
  })

  const [viewMode, setViewMode] = React.useState<'desktop' | 'mobile'>(
    'desktop'
  )

  const article = mode === 'fetchData' ? _article : { content: articleContent }

  return isLoading ? (
    <Loading />
  ) : (
    <div className="h-full bg-grey">
      <div className="flex justify-center">
        <Radio.Group
          value={viewMode}
          onChange={e => setViewMode(e.target.value)}>
          <Radio.Button value="desktop">桌面預覽</Radio.Button>
          <Radio.Button value="mobile">手機預覽</Radio.Button>
        </Radio.Group>
      </div>
      {mode === 'fromProps' && (
        <span className="block text-center text-white mt-2">
          *文章編輯的預覽模式只能檢視內文
        </span>
      )}
      <div className={'flex justify-center items-center py-10'}>
        <div
          className={cx(
            'w-[90vw] max-w-[1080px] h-min md:h-min-[1080px] overflow-auto',
            {
              'w-[390px] border-2 border-gray-800': viewMode === 'mobile',
            }
          )}>
          <div className="w-full bg-white">
            {article.desktopImgPreviewUrl && (
              <div className="relative w-full flex items-center aspect-[1280/568]">
                <img
                  src={
                    viewMode === 'mobile'
                      ? article.mobileImgPreviewUrl
                      : article.desktopImgPreviewUrl
                  }
                  alt={article.title || '文章橫幅'}
                  className="object-cover"
                  css={css`
                    position: absolute;
                    height: 100%;
                    width: 100%;
                    inset: 0px;
                    color: transparent;
                  `}
                />
              </div>
            )}

            <article
              css={css`
                --spacing: 0.25rem;
                padding-block: calc(var(--spacing) * 8);
                padding-inline: calc(var(--spacing) * 4);
              `}
              className="">
              <p
                css={css`
                  margin-bottom: calc(var(--spacing) * 6);
                `}
                className="text-gray-500">
                {momentToString(article.publishAt, 'YYYY-MM-DD')}
              </p>
              <h1
                css={css`
                  all: revert;
                  margin-top: 0px;
                `}
                className="font-bold">
                {article.title}
              </h1>
              <div
                className="prose max-w-none article-content"
                dangerouslySetInnerHTML={{ __html: article.content }}
              />
            </article>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ArticlePreview
